import Vue from "vue";
import Vuex from "vuex";
import Configuration from "../core/Configuration";

Vue.use(Vuex);

/**
 * @typedef StateInterface
 * @property {boolean} showHeader
 * @property {boolean} showFooter
 * @property {boolean} showMenu
 * @property {boolean} showHeaderLeft
 * @property {string} headerTitle
 * @property {string} headerIcon
 * @property {boolean} cogir
 * @property {boolean} isDesktop
 * @property {number} organization
 * @property {number} property
 */

export default new Vuex.Store({

  state: /** @type {StateInterface} */ ({
    showHeader: false,
    showFooter: false,
    showMenu: false,
    showHeaderLeft: false,
    headerTitle: "page.home",
    headerIcon: "/svg/home.svg",
    organization: Configuration.read("organization") || -1,
    property: Configuration.read("property") || -1,
    cogir: false,
    isDesktop: false,
    isTablet: false
  }),

  mutations: {
    /**
     * @param state
     * @param {{showHeader: boolean, showFooter: boolean, showHeaderLeft: boolean,
     *          headerTitle: string, headerIcon: string}} params
     */
    setDisplay(state, {showHeader, showFooter, showHeaderLeft, headerTitle, headerIcon}) {
      state.showHeader = showHeader;
      state.showFooter = showFooter;
      state.showHeaderLeft = showHeaderLeft;
      state.headerTitle = headerTitle;
      state.headerIcon = headerIcon;
    }
  }

});
